// extracted by mini-css-extract-plugin
export default {"table":"AlertNotificationRecipients_table__oIcGy"};